@if (isVisible) {
  <div class="checkbox">
    <input class="show-for-sr screen-only" type="checkbox" [id]="controlId" [name]="controlName" [(ngModel)]="contextValue" [formControl]="formGroup.controls[componentData.key]" (ngModelChange)="change()">
    <div class="flex-row">
      <form-control-label [id]="controlId" [question]="componentData" [flow]="flowComponent">
        <span class="checkbox-box screen-only" aria-hidden="true" styledCheckbox>
          <span class="checkbox-check" aria-hidden="true">&#x2714;</span>
        </span>
      </form-control-label>
    </div>
    <div class="print-only">
      <span [innerHTML]="question?.label | safeHtml"></span>
      <span class="print-only">
        @if (contextValue) {
          <input type="checkbox" checked />
        }
        @if (!contextValue) {
          <input type="checkbox" />
        }
      </span>
    </div>
  </div>
}

